/* eslint-disable new-cap */
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable max-statements */

import {isEmptyOrder} from './reducerUtils';
export const removedEmptyOrders = (orders) => {
  return orders.filter((order) => !isEmptyOrder(order));
};

export const addCeros = (orders) => {
  return orders.map((order) => {
    const newOrder = {...order};
    if (newOrder.cb === '') {
      newOrder.cb = '0';
    }
    if (newOrder.ch === '') {
      newOrder.ch = '0';
    }
    if (newOrder.cl === '') {
      newOrder.cl = '0';
    }
    if (newOrder.fl === '') {
      newOrder.fl = '0';
    }
    if (newOrder.it === '') {
      newOrder.it = '0';
    }
    if (newOrder.tde === '') {
      newOrder.tde = '0';
    }
    if (newOrder.tcomercial === '') {
      newOrder.tcomercial = '0';
    }
    if (newOrder.tdedp === '') {
      newOrder.tdedp = '0';
    }
    if (newOrder.ty === '') {
      newOrder.ty = '0';
    }
    return newOrder;
  });
};

export const mapColorsToDropdownList = (list) => {
  return list.map((item) => {
    return {
      'key': `${item.outDoorColor}-${item.inDoorColor}`,
      'value': `${item.outDoorColor}-${item.inDoorColor}`,
      'text': `${item.outDoorColor} ${item.outDoorColorDescription}- ${item.inDoorColor} ${item.inDoorColorDescription}`,
    };
  });
};

export const mapModelsToDropdownList = (list) => {
  return list.map((item) => {
    return (
      item.sfx !== 'S/N' &&
      item.sfx !== '.' &&
      item.sfx && {
        'key': `${item.sfx}/${item.model}/${item.description}`,
        'value': `${item.sfx}&${item.model}&${item.description}`,
        'text': `${item.sfx}/${item.model} ${item.description}`,
      }
    );
  });
};

export const mapOrdersToTable = (orders) => {
  return orders.map((order) => {
    const newOrder = {};
    for (const prop in order) {
      newOrder[prop] = order[prop].value;
    }
    return newOrder;
  });
};

const stateRegisterMapper = {
  'A': 'ACTIVO',
  'I': 'INACTIVO',
};

export const customValuesOrders = (key, value, row) => {
  const dollarUS = Intl.NumberFormat('de-DE');
  if (key === 'dateOfArrivalText') {
    const dateOfArrival = row.etaTrackingDate || row.dateOfArrivalText;
    return dateOfArrival ? dateOfArrival.substring(0, 10) : dateOfArrival;
  }
  if (key === 'dateOfShipmentText') {
    return value ? value.substring(0, 10) : value;
  }
  if (key === 'shipmentText') {
    return parseInt(row.shipment, 10) ? `Embarque ${row.shipment}` : 'Pendiente';
  }
  if (key === 'cif') {
    return value ? `$ ${dollarUS.format(value)}` : '';
  }
  if (key === 'register_state') {
    return stateRegisterMapper[value] || value;
  }
  if (key.includes('Date')) {
    return value ? value.substring(0, 10) : value;
  }
  return value;
};

export const getBlockedShipments = (data) => {
  const lockedShipments = [];
  data.forEach((shipment) => {
    if (shipment.editable === 'N') {
      lockedShipments.push(shipment.shipment);
    }
  }
  );
  return [...new Set(lockedShipments.filter((n) => n))];
};

export const getErrorMessage = (sumCurrentShipment, validateOrderValues) => {
  if (!validateOrderValues) {
    return 'Por favor llene los campos de "Proveedor" y "Año modelo" en la cabecera.';
  } else if (!sumCurrentShipment) {
    return 'La suma total del embarque debe ser mayor a cero.';
  }
  return '';
};

export const sumShipment = (shipmentData = [], shipmentNumber) => {
  let sum = 0;
  let sumNL = 0;
  let sumDP = 0;
  let sumFL = 0;
  let sumDN = 0;
  let sumDE = 0;
  for (let i = 0; i < shipmentData.length; i++) {
    sum += parseInt(shipmentData[i][`shipmentItem${shipmentNumber}`] || 0, 10);
    if (shipmentData[i].destiny === 'NL') {
      sumNL += parseInt(shipmentData[i][`shipmentItem${shipmentNumber}`] || 0, 10);
    } else if (shipmentData[i].destiny === 'DP') {
      sumDP += parseInt(shipmentData[i][`shipmentItem${shipmentNumber}`] || 0, 10);
    } else if (shipmentData[i].destiny === 'FL') {
      sumFL += parseInt(shipmentData[i][`shipmentItem${shipmentNumber}`] || 0, 10);
    } else if (shipmentData[i].destiny === 'DE') {
      sumDE += parseInt(shipmentData[i][`shipmentItem${shipmentNumber}`] || 0, 10);
    } else if (shipmentData[i].destiny === 'DN') {
      sumDN += parseInt(shipmentData[i][`shipmentItem${shipmentNumber}`] || 0, 10);
    }
  }
  return {sum, sumNL, sumDP, sumFL, sumDE, sumDN};
};


export const mapDealersToDropdownList = (list) => {
  if (list) {
    return list.map((item) => {
      return {
        'key': item.identification,
        'value': item.identification,
        'text': `${item.name}`,
      };
    });
  }
  return [];
};

export const dealersToArray = (listDealers) => listDealers.map((dealer) => dealer?.identification);

export const generateShipmentDropdown = (shipmentsNumber) => {
  const resp = [{
    'key': '0',
    'value': '0',
    'text': 'PENDIENTE',
  }];
  for (let i = 1; i <= shipmentsNumber; i++) {
    resp.push({
      'key': i,
      'value': i,
      'text': `EMBARQUE ${i}`,
    });
  }
  return resp;
};
